const carrierDomains = [
  'ezweb.ne.jp',
  'ido.ne.jp',
  'biz.ezweb.ne.jp',
  'augps.ezweb.ne.jp',
  'uqmobile.jp',
  'docomo.ne.jp',
  'mopera.net',
  'dwmail.jp',
  'pdx.ne.jp',
  'wcm.ne.jp',
  'willcom.com',
  'y-mobile.ne.jp',
  'emnet.ne.jp',
  'emobile-s.ne.jp',
  'emobile.ne.jp',
  'ymobile1.ne.jp',
  'ymobile.ne.jp',
  'jp-c.ne.jp',
  'jp-d.ne.jp',
  'jp-h.ne.jp',
  'jp-k.ne.jp',
  'jp-n.ne.jp',
  'jp-q.ne.jp',
  'jp-r.ne.jp',
  'jp-s.ne.jp',
  'jp-t.ne.jp',
  'sky.tkc.ne.jp',
  'sky.tkk.ne.jp',
  'sky.tu-ka.ne.jp',
  'disney.ne.jp',
  'i.softbank.jp',
  'softbank.ne.jp',
  'vodafone.ne.jp',
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'au.com',
  'softbank.ne.jp',
  'disney.ne.jp',
  'd.vodafone.ne.jp',
  'h.vodafone.ne.jp',
  't.vodafone.ne.jp',
  'c.vodafone.ne.jp',
  'k.vodafone.ne.jp',
  'r.vodafone.ne.jp', 's.vodafone.ne.jp', 'n.vodafone.ne.jp', 'q.vodafone.ne.jp',
  'jp-d.ne.jp', 'jp-h.ne.jp', 'jp-t.ne.jp', 'jp-c.ne.jp', 'jp-k.ne.jp',
  'jp-r.ne.jp', 'jp-s.ne.jp',
  'jp-n.ne.jp', 'jp-q.ne.jp',
  'pdx.ne.jp',
  'emnet.ne.jp',
  'willcom.com'
];


// 1. 会員登録フォーム
CF.ready(function() {
	var myForm = document.querySelector('form[data-cf-form]');

  // バリデーション定義
  var validation = {
    comparator: function isNotCarrierEmail(fieldValue) {
      if (!fieldValue || fieldValue.indexOf('@') === -1) {
        // メールアドレス形式でない場合は、他のバリデーションに任せる
        return true;
      }
      var domain = fieldValue.split('@')[1].toLowerCase();
      // carrierDomainsにドメインが含まれていないかチェック
      return !carrierDomains.some(function(carrierDomain) {
        return domain === carrierDomain;
      });
    },
    errorMessage: '確実にメールをお届けするために、キャリアメールでのご登録はお控えください'
  };

  // emailフィールドにバリデーターを追加 (キーは 'email' と仮定)
  if (myForm && myForm.cfForm) {
    try {
      myForm.cfForm.addValidator(validation, 'email');
    } catch (e) {
      console.error("Failed to add email validator:", e);
    }
  } else {
    console.error("Could not add email validator: myForm or myForm.cfForm is not available.");
  }

});

// 2. Line会員登録フォーム
document.addEventListener('DOMContentLoaded', function () {
	const myForm = document.querySelector('#socialplus-customer-registration-form');
  if (!myForm) {
    // console.log('Line registration form not found.'); // 必要ならログ出力
    return; // フォームが見つからなければ何もしない
  }

	const emailElement = myForm.querySelector('#customer_email'); // ID検索はquerySelectorでも可能
	const registerButton = myForm.querySelector('#socialplus_form_submit_button');

	if (!emailElement || !registerButton) {
    console.error('Required elements (email or button) not found in Line registration form.');
    return; // 必要な要素がなければ処理中断
  }

  // エラーメッセージ表示用の要素を作成 (なければ)
  let errorElement = myForm.querySelector('.line-email-error-message');
  if (!errorElement) {
    errorElement = document.createElement('p'); // 例としてpタグを使用
    errorElement.className = 'line-email-error-message';
    errorElement.style.color = 'red'; // 簡単なスタイル設定
    errorElement.style.display = 'none'; // 初期状態は非表示
    // emailElementの直後に追加 (親要素が存在することを確認)
    if (emailElement.parentNode) {
       emailElement.parentNode.insertBefore(errorElement, emailElement.nextSibling);
    } else {
        console.error('Cannot insert error message: email element has no parent.');
        return;
    }
  }
  const errorMessageText = '確実にメールをお届けするために、キャリアメールでのご登録はお控えください';

  // ドメインチェックとUI制御を行う関数
  function checkEmailAndControlButton() {
    const emailValue = emailElement.value;
		console.log(emailValue);
    let isCarrier = false;

    if (emailValue && emailValue.indexOf('@') > -1) {
      const domain = emailValue.split('@')[1].toLowerCase();
      isCarrier = carrierDomains.some(carrierDomain => domain === carrierDomain);
    }

    if (isCarrier) {
      // キャリアメールの場合
      errorElement.textContent = errorMessageText;
      errorElement.style.display = 'block';
      registerButton.disabled = true;
    } else {
      // キャリアメールでない、またはメール形式でない場合
      errorElement.textContent = '';
      errorElement.style.display = 'none';
      registerButton.disabled = false;
    }
  }

	// --- イベントリスナーと初期チェック ---

  // 初期表示時のチェック
  checkEmailAndControlButton();

  // emailフォーム変更時のチェック (inputイベントで入力ごとにチェック)
  emailElement.addEventListener('input', checkEmailAndControlButton);

});